<span [class]="textStyle">{{text}}</span>
<span [class]="mobileTextStyle">{{mobileText}}</span>
